module.exports = __webpack_public_path__ + "img/share.23976235.png";